module.exports = __webpack_public_path__ + "img/file-icon.0f18c7ba.svg";